import { CommonModule } from '@angular/common';
import { APP_INITIALIZER, ModuleWithProviders, NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

import { NullValidationHandler, OAuthModule, OAuthService, OAuthStorage, ValidationHandler } from 'angular-oauth2-oidc';
import { environment } from 'src/environments/environment';

import {
  MdbButtonModule,
  MdbCheckboxModule,
  MdbFormsModule,
  MdbIconModule,
  MdbToolbarModule,
  MdbTooltipModule
} from 'src/lib/mdb5-adapted/public-api';

import { UserService } from '../services/lmsuser.service';
import { TokenService } from '../interceptors/token.service';
import { initializeAuth } from './oauth.init';

export function oAuthStorageFactory(): OAuthStorage { return localStorage; };

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    ReactiveFormsModule,
    OAuthModule.forRoot({
      resourceServer: {
        allowedUrls: [environment.apiBioUrl, environment.apiDocUrl, environment.apiUrl, environment.keycloakHost],
        sendAccessToken: true,
      }}
    ), // ✅ This is essential
  ],
  providers: [
    UserService,
    { provide: OAuthStorage, useFactory: oAuthStorageFactory },
    { provide: ValidationHandler, useClass: NullValidationHandler },
  ],
})
export class AuthModule {
  static forRoot(): ModuleWithProviders<AuthModule> {
    return {
      ngModule: AuthModule,
      providers: [
        { provide: APP_INITIALIZER, useFactory: initializeAuth, deps: [OAuthService, UserService, TokenService], multi: true }],
    };
  }
}
